import { darken, lighten, makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import { nth } from "lodash-es";
import { Children } from "react";

/**
 * Contains style information for the documnents page.
 */
// Define shared styles
export const useDashboardPageStyles = makeStyles(theme => ({
    root: {
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
    },
    workspace: {
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#ffffff",
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[1],
        padding: theme.spacing(3),
    },
    titleRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(1),
    },
    title: {
        fontWeight: 700,
        color: theme.palette.primary.main,
    },
    titleBorder: {
        width: "100%",
        height: "2px",
        backgroundColor: theme.palette.primary.light,
        marginBottom: theme.spacing(2),
    },
    accordion: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        marginBottom: theme.spacing(2),
    },
    accordionSummary: {
        backgroundColor: theme.palette.action.hover,
        padding: theme.spacing(1, 2),
        background: "red",
    },
    accordionDetails: {
        display: "flex",
        flexDirection: "column",
        padding: theme.spacing(2),
    },
    documentCategories: {
        marginTop: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
    },

    productGroupTitleContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    productGroupCounterContainer: {
        backgroundColor: theme.palette.grey[200],
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(0.5, 1),
    },
    checklistSubCategory: {
        marginLeft: theme.spacing(2),
        fontStyle: "italic",
    },
    documentLink: {
        color: theme.palette.primary.main,
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    drawingDocumentItem: {
        margin: theme.spacing(1, 0),
    },
}));

export const useDocumentsPageStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        flexDirection: "column",
    },
    titleRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(2),
    },
    title: {
        fontSize: "1.5rem",
        fontWeight: 600,
        color: theme.palette.primary.main,
    },
    titleBorder: {
        width: "100%",
        height: "2px",
        backgroundColor: theme.palette.primary.light,
        marginBottom: theme.spacing(2),
    },
    accordion: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        marginBottom: theme.spacing(1),
        boxShadow: theme.shadows[1],
    },
    accordionSummary: {
        backgroundColor: theme.palette.action.hover,
        padding: theme.spacing(1.5, 2),
        "& .MuiAccordionSummary-content": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
    },
    accordionDetails: {
        backgroundColor: "#ffffff",
        // padding: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
    },
    documentCategories: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        width: "100%",
        columnGap: "60px",
    },
    accordionTitle: {
        fontSize: "14px",
        lineHeight: "21px",
        color: "#3C3C3B",
        fontWeight: "bold",
        letterSpacing: "-0.18px",
    },
    productGroupTitleContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    productGroupCounterContainer: {
        backgroundColor: theme.palette.grey[200],
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(0.5, 1),
        fontSize: "0.875rem",
        color: theme.palette.text.secondary,
    },
    checklistSubCategory: {
        marginLeft: theme.spacing(2),
        fontStyle: "italic",
        color: theme.palette.text.secondary,
    },
    drawingDocumentItem: {
        margin: theme.spacing(1, 0),
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[1],
    },
    categoryContainer: {
        marginBottom: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        borderBottom: "1px dashed #ced4da",
    },
    categoryContainerLast: {
        borderBottom: "none",
        marginBottom: 0,
        paddingBottom: 0,
    },
    categoryName: {
        fontWeight: "bold",
        fontSize: "12px",
        lineHeight: "15px",
        marginBottom: theme.spacing(1),
    },
    gridContainer: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "10px",
    },
    documentLink: {
        textDecoration: "none",
        color: theme.palette.primary.main,
        fontWeight: "bold",
        "&:hover": {
            textDecoration: "underline",
        },
    },

    documentPage: {
        "& .MuiCollapse-container ": {
            boxShadow: "unset",
        },
    },
    documentHeader: {
        display: "flex",
        background: "#3C3C3B",
        padding: "24px 17px",
        fontSize: "21px",
        lineHeight: "25px",
        color: "#FFFFFF",
        fontWeight: "bold",
        gap: "10px",
    },
    accordionHeader: {
        borderStyle: "solid",
        "&.Mui-expanded": {
            borderBottom: "  1px dashed #ced4da",
        },
        "& .MuiAccordionSummary-content": {
            alignItems: "center",
            padding: "18px 18px 15px 0px",
        },
    },

    ismobileViewAccordionBlock: {
        "& .baseHeader": {
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            "& span": {
                fontSize: "10px",
            },
        },
    },

    isMobileDocumentCategories: {
        gridTemplateColumns: "1fr",
    },
    isMobiledocumentItem: {
        gridTemplateColumns: "1fr",
    },
    isMobileaccordionHeader: {
        "& .MuiAccordionSummary-content": {
            padding: "16px 0",
            width: "100%",
            "& > svg": {
                height: "16px",
                width: "16px",
            },
        },
    },
    isMobileworkspace: {
        paddingBottom: "80px",
    },
    [theme.breakpoints.down("sm")]: {
        accordionTitle: {
            fontSize: "12px",
            lineHeight: "15px",
        },
        accordionDetails: {
            padding: "10px 0",
            margin: "0px !important",
        },
    },
}));

// export const DocumentsPageStyles = makeStyles((theme: Theme) => ({
//     root: {},
//     documentCategories: {
//         margin: "0 18px",
//     },
//     documentCategory: {
//         display: "flex",
//         flexDirection: "column",
//         padding: "17.5px 0 15px 0",
//         "&:not(:last-child)": {
//             borderBottom: "1px dashed #ced4da",
//         },
//     },
//     documentCategoryTitle: {
//         fontSize: "12px",
//         fontWeight: "bold",
//         marginBottom: "10px",
//     },
//     documentLink: {
//         overflowWrap: "anywhere",
//         "& > div": {
//             margin: "2.5px 0 2.5px -4px",
//         },
//     },
//     [theme.breakpoints.up("md")]: {
//         titleRow: {
//             padding: "27px 18px 15px 18px",
//             display: "flex",
//             justifyContent: "space-between",
//             "& > button": {
//                 padding: "0",
//             },
//             "& > h5": {
//                 padding: "0px",
//             },
//             "& .MuiSvgIcon-root": {
//                 margin: "-7px",
//                 fontSize: "35px",
//             },
//         },
//         title: {
//             fontSize: "20px",
//             fontWeight: "bold",
//         },
//         titleBorder: {
//             borderBottom: "1px solid #CED4DA",
//             margin: "0 18px 16px",
//         },
//         documentCategories: {
//             margin: "-10px 18px 0 18px",
//         },
//         documentCategory: {
//             "& > div": {
//                 display: "grid",
//                 gridTemplateColumns: "repeat(auto-fill,minmax(300px, 1fr))",
//                 columnGap: "18px",
//             },
//         },
//     },
//     accordion: {
//         "& > div.MuiCollapse-container": {
//             background: "none",
//         },
//     },
//     accordionSummary: {},
//     productGroupAccordionDetails: {
//         padding: "0px",
//         flexWrap: "wrap",
//     },
//     productGroupAccordionDetail: {},
//     productGroupTitleContainer: {
//         display: "flex",
//         flexDirection: "row",
//         alignItems: "center",
//         flex: "1 1 auto",
//         "& > p": {
//             fontSize: "14px",
//             fontWeight: "bold",
//             marginRight: "10px",
//         },
//     },
//     productGroupCounterContainer: {
//         display: "flex",
//         flexDirection: "row",
//         alignItems: "center",
//         marginLeft: "auto",
//     },
//     productGroupChoiceCounterContainer: {
//         display: "flex",
//         flexDirection: "row",
//         marginLeft: "20px",
//         alignItems: "center",
//         "& > svg": {
//             fontSize: "15px",
//             stroke: "black",
//             strokeWidth: "0.5px",
//         },
//     },
//     checklistSubCategory: {
//         fontSize: "12px",
//         fontWeight: "bold",
//         margin: "15px 0px",
//         padding: "10px 0px",
//         flexBasis: "100%",
//         borderTop: "1px dashed #ced4da",
//     },
// }));
